var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("details page "+_vm._s(_vm.pair.id)+" "+_vm._s(_vm.pair.data)+" "+_vm._s(_vm.pair.data === null))])])
}
var staticRenderFns = []

export { render, staticRenderFns }